#import "../../../../../../core/select/fragments/audience-basic.graphql"

mutation SyncMcfxAudience($input: McfxAudienceSyncInAppInput!) {
    mcfxAudienceSyncInApp(input: $input) {
        ...AudienceBasic
    }
}
